class Customer.ConversationAttributeView extends Backbone.View
  error: JST['backbone/templates/customer/custom_attributes/error']
  titleClassName: ''
  className: 'custom-attribute'

  initialize: ({model}) ->
    @model = model
    @$el.toggleClass('required', @model.isRequired())
    @titleView = new Customer.ConversationAttributeTitleView
      titleClassName: @titleClassName
      title: @model.get('definition').get('name')

  render: ->
    @$el.html(@template(model: @model))
    @$el.prepend(@titleView.render().el)
    @

  initialValues: ->
    _.map(@model.get('value'), (val) -> val['value']) || []

  _errorTemplate: (error) =>
    @error({error})

  getDefinitionCode: =>
    @model.get('definition').get('code')

  afterRender: ->
